exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul li{font-size: 14px; padding: 7px 0;}\n.mat-dialog-content{margin: 0 -24px 0 0;}\n.send_dailog_box{min-width: 800px;}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/admin/email/email-sent-to/email-sent-to.component.css
// module id = ../../../../../src/app/admin/email/email-sent-to/email-sent-to.component.css
// module chunks = 39